import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { inject, observer, Provider } from 'mobx-react';

import compose from 'helpers/compose';

import { Params } from 'pages/Accounts/Edit/accountEditRoutes';
import { RootStore } from 'stores/rootStore';
import { WorkflowQuestionnaireStore } from 'stores/workflowStores/workflowQuestionnaireStore/newWorkflowQuestionnaireStore';
import { AccountDetailStore } from 'stores/account/accountDetailStore';
import Evaluation from './Evaluation';
import Questionnaire from './Questionnaire';

interface Props {
  rootStore: RootStore;
  detailStore?: AccountDetailStore;
  goFwd?: () => void;
  //detailMode?: boolean;
  readOnly?: boolean;
  userMode?: boolean;
  accountId?: string;
}

const Investments: React.FC<Props> = ({
  rootStore,
  goFwd,
  //detailMode,
  detailStore,
  readOnly,
  userMode,
  ...props
}) => {
  const detailMode = !!detailStore;
  const accountIdParam = useParams<Params>().accountId;
  const accountId = props.accountId || accountIdParam;
  const [store] = useState(new WorkflowQuestionnaireStore(rootStore, accountId, detailMode, userMode));
  const currency = detailMode ? detailStore!.currency : rootStore.stores.editAccountStore.currency;

  useEffect(() => {
    rootStore.stores.editAccountStore.setStep(3);
  }, [rootStore.stores.editAccountStore]);

  useEffect(() => {
    store.setAccountId(accountId);
    store.fetchQuestionnaireData(false);
    return function reset() { store.resetInQuestions() }
  }, [store, accountId]);

  if (store.showResult && !store.resultData) return null;

  if (detailStore?.newEdit) {
    detailStore.setNewEdit(false);
    store.handleTakeAgain();
  }

  return (
    <Provider store={store}>
      {store.showResult ? (
        <Evaluation
          detailMode={detailMode}
          goFwd={goFwd}
          readOnly={readOnly}
          userMode={userMode}
          takeAgainDisabled={detailMode && rootStore.stores.uiStore.userMenuData.profileLockActive}
        />
      ) : (
        <Questionnaire detailMode={detailMode} readOnly={readOnly} currency={currency} />
      )}
    </Provider>
  );
};

export default compose(inject('rootStore'), observer)(Investments);
